import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const faqJsonLd = (faqs) =>
  faqs?.length
    ? { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.question, acceptedAnswer: { "@type": "Answer", text: f.answer } })) }
    : null;

export const FaqList = ({ faqs }) => (
  <Accordion type="single" collapsible className="border-t border-[#27272A]" data-testid="faq-list">
    {faqs.map((f, i) => (
      <AccordionItem key={f.id} value={f.id} className="border-b border-[#27272A]">
        <AccordionTrigger className="py-6 text-left text-lg md:text-xl font-display font-semibold hover:no-underline hover:text-[#00E5FF]" data-testid={`faq-trigger-${i}`}>
          {f.question}
        </AccordionTrigger>
        <AccordionContent className="pb-6 text-zinc-400 text-base leading-relaxed max-w-3xl whitespace-pre-line">{f.answer}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
